import { Outlet } from 'react-router-dom';
import UserDashboardNavbar from '../../components/Navbar/UserDashboardNavbar';

export default function UserDashboardLayout() {
    return (
        <>
            <UserDashboardNavbar />
            <Outlet />
        </>
    );
}
